enum FieldType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Select = 'select',
  MultiSelect = 'multiSelect',
  Switch = 'switch',
  Checkbox = 'checkbox',
  Date = 'date',
  DateTime = 'datetime',
  ColorPicker = 'colorPicker',
  Autocomplete = 'autocomplete',
}

export default FieldType;
